

































































































































































































































import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import CountrySelect from "@/components/CountrySelect.vue";
import config from "@/configs";

interface Data {
  form: any;
  isCreateNewAccount: boolean;
  radioGroup: string | null;
  company: string;
}

export default Vue.extend({
  name: "AccountCardContent",
  components: { CountrySelect },
  data: (): Data => {
    return {
      company: config?.settings.company || "",
      isCreateNewAccount: false,
      radioGroup: null,
      form: {
        country: null,
        business_type: null,
        tos_shown_and_accepted: true,
        company: {
          name: null,
        },
        individual: {
          first_name: null,
          last_name: null,
        },
      },
    };
  },
  computed: {
    ...mapGetters("auth", {
      loading: "getLoading",
    }),
    ...mapGetters("auth", [
      "getUserAccounts",
      "getAuthInitials",
      "getAuthDisplayName",
      "getAuthEmail",
      "getLoadingSession",
    ]),
    ...mapGetters("snackbar", ["getVisibility"]),
    hasUserAccounts() {
      return (
        this.getUserAccounts && Object.keys(this.getUserAccounts).length > 0
      );
    },
  },
  methods: {
    ...mapActions("auth", ["logout", "createAccount", "changeSession"]),
    ...mapMutations("snackbar", ["setVisibility"]),
    isFormValid() {
      const isCompanyNameSet = !!this.form.company.name;
      const isIndividualNameSet = !!(
        this.form.individual.first_name && this.form.individual.last_name
      );
      return this.form.business_type === "company"
        ? isCompanyNameSet
        : isIndividualNameSet;
    },
    getAccountNameText() {
      if (!this.form.business_type) {
        return "";
      } else {
        return this.form.business_type === "company"
          ? this.$t("accounts.andMyCompanyNameIs")
          : this.$t("accounts.andMyNameIs");
      }
    },
    isStripeConnectAccountCustom() {
      return config?.stripe.connectAccountType === "custom";
    },
  },
});
